import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ClientFilterModel, StoreListFilterModel, UserListFilterModel, DiscountModel, PermissionGroupModal, UserPermissionGroupList } from '../../models/client';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';
import { APIResponse, ApiResponse } from '@app/shared/services/core/ICore.interface';
import { GetProgressInterface } from '@app/feature/super-admin/services/client/GetProgress.interface';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private http: HttpClient) { }

  GetClientList(filterModel: ClientFilterModel) {
    return this.http.post(environment.baseUrl + AppConstant.CLIENT_LIST, filterModel);
  }

  /** func to make api call to get client detail based on clientid*/
  GetClientDetail(clientid: number) {
    return this.http.get(environment.baseUrl + AppConstant.CLIENT_DETAIL + '?UserId=' + clientid);
  }

  /** Func to make API call to update store detail.
   * Update store status ,
   * Update/Set % commission
   */
  UpdateStoreDetail(model: any) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_DETAIL, model);
  }

  GetStoreList(filterModel: StoreListFilterModel) {
    return this.http.post(environment.baseUrl + AppConstant.SUPER_ADMIN_STORE_LIST, filterModel);
  }

  GetGroupedStoreList(searchBy: string = '') {
    return this.http.post(environment.baseUrl + AppConstant.SUPER_ADMIN_GROUPED_STORE_LIST, { searchBy });
  }

  GetStoresByUrl(storeUrl: string, filterModel: StoreListFilterModel) {
    return this.http.post(environment.baseUrl + AppConstant.SUPER_ADMIN_STORE_LIST, { ...filterModel, StoreUrl: storeUrl });
  }

  UpdateStoreOwner(storeId: number, storeUrl: string) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_STORE_OWNER, { StoreId: storeId, StoreUrl: storeUrl });
  }
  UpdateStoreShopifyStatus(storeId: number, isActive: boolean) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_STORE_SHOPIFY_STATUS, { StoreId: storeId, IsActive: isActive, UserId: Number(localStorage.getItem('userId')) || 0 });
  }
  GetUserList(filterModel: UserListFilterModel) {

    return this.http.post(environment.baseUrl + AppConstant.SUPER_ADMIN_User_LIST, filterModel);
  }
  syncCat() {
    return this.http.get(environment.baseUrl + AppConstant.GET_CAT_QUERY);
  }
  syncProduct() {
    return this.http.get(environment.baseUrl + AppConstant.GET_PRODUCT_ASYNC);
  }
  GetSyncedProduct() {    
    return this.http.get(environment.baseUrl + AppConstant.GET_SYNCED_PRODUCT_ASYNC);
  }
  getProgress() {
    return this.http.get<APIResponse<GetProgressInterface>>(environment.baseUrl + AppConstant.GET_PROGRESS_PRODUCT_ASYNC);
  }

  resendConfirmationEmail(userEmail: any) {
    return this.http.get(environment.baseUrl + AppConstant.SUPER_ADMIN_RESEND_CONFORMATION_EMAIL + '?Email=' + userEmail);
  }
  resendPasswordEmail(userEmail: any) {
    return this.http.get(environment.baseUrl + AppConstant.SUPER_ADMIN_RESET_PASSWORD_EMAIL + '?Email=' + userEmail);
  }


  /** Get store categories for category SCREEN to add/edit/delete */
  GetStoreCategories() {
    return this.http.get<any>(environment.baseUrl + AppConstant.STORECATEGORY_LIST);
  }
  UpdateDiscount(data: DiscountModel) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.UPDATE_DISCOUNT, data);
  }
  GetPermissionList(permissionGroupId: number) {
    return this.http.get(environment.baseUrl + AppConstant.SUPER_ADMIN_PERMISSION_LIST + '?permissionGroupId=' + permissionGroupId);
  }

  AddPermissionGroups(data: PermissionGroupModal) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.ADD_PERMISSION_GROUP, data);
  }
  GetPermissionGroupsList(userid: number) {
    return this.http.get(environment.baseUrl + AppConstant.SUPER_ADMIN_PERMISSION_GROUP_LIST + '?userId=' + userid);  
  }
  SaveUserPermissions(data: UserPermissionGroupList) {
    return this.http.post(environment.baseUrl + AppConstant.SAVE_USER_PERMISSIONS, data);
  }

  GetPermissionGroupUser(permissionGroupId: number) {
    return this.http.get(environment.baseUrl + AppConstant.GET_PERMISSION_GROUP_USERS + '?permissionGroupId=' + permissionGroupId);
  }
  DeletePermissionGroupUser(permissionGroupId: number) {
    return this.http.get(environment.baseUrl + AppConstant.DELETE_PERMISSION_GROUP + '?permissionGroupId=' + permissionGroupId);
  }
  GetOpenAPIClientList() {
    return this.http.get(environment.baseUrl + AppConstant.OPENAPI_CLIENT_LIST);
  }
  UpdateSourceName(obj: any) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.UPDATE_SOURCE_NAME, obj);
  }
  UpdateClientDetails(model: any) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_CLIENT_DETAIL, model);
  }
  UpdateOrderDeskConfig(obj: any) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.UPDATE_ORDER_DESK_CONFIG, obj);
  }
  DeleteOrderDeskConfig(userId: number) {
    return this.http.delete<APIResponse<{}>>(environment.baseUrl + AppConstant.DELETE_ORDER_DESK_CONFIG + '?UserId=' + userId);
  }
  UpdateSOPHostedValue(obj : any){
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.UPDATE_SOPHOSTED_VALUE, obj);
  }
  addClient(obj: any) {
    return this.http.post(environment.baseUrl + AppConstant.ADD_CLIENT, obj);
  };
}
